module.exports = __webpack_public_path__ + "static/media/verbal.b70b3d44.svg";